import { OnboardingFormFields } from '@Types/index';
import { ErrorType } from '@Services/errors/errorType.ts';
import type { IErrorHandling } from '@Types/index';

export const AddressErrorMap = {
  INVALID_CITY: { errorCode: 4043, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_COUNTRY: { errorCode: 4044, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_STATE: { errorCode: 4045, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_POSTAL: { errorCode: 4046, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_LINE1: { errorCode: 4052, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_LINE2: { errorCode: 4076, errorType: ErrorType.BUSINESS_LOGIC },
  ADDRESS_PO_BOX: { errorCode: 4066, errorType: ErrorType.BUSINESS_LOGIC },
  ADDRESS_NOT_DELIVERABLE: { errorCode: 40067, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_LINE1_PO_BOX: { errorCode: 41197, errorType: ErrorType.BUSINESS_LOGIC },
  BUSINESS_ADDRESS_AGENT: { errorCode: 61001, errorType: ErrorType.BUSINESS_LOGIC },
  NON_US_BUSINESS_ADDRESS_AGENT: { errorCode: 61002, errorType: ErrorType.BUSINESS_LOGIC },
  BUSINESS_ADDRESS_FOR_CARD_SHIP_INVALID: { errorCode: 61004, errorType: ErrorType.BUSINESS_LOGIC },
  BUSINESS_ADDRESS_MUST_BE_US: { errorCode: 61005, errorType: ErrorType.BUSINESS_LOGIC },
  BUSINESS_REGISTERED_ADDRESS_NOT_EXIST: { errorCode: 50872, errorType: ErrorType.BUSINESS_LOGIC },
};

export const getAddressErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      AddressErrorMap.BUSINESS_ADDRESS_AGENT.errorCode,
      {
        errorCode: AddressErrorMap.BUSINESS_ADDRESS_AGENT.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.NON_US_BUSINESS_ADDRESS_AGENT.errorCode,
      {
        errorCode: AddressErrorMap.NON_US_BUSINESS_ADDRESS_AGENT.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.INVALID_LINE1_PO_BOX.errorCode,
      {
        errorCode: AddressErrorMap.INVALID_LINE1_PO_BOX.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.INVALID_CITY.errorCode,
      {
        errorCode: AddressErrorMap.INVALID_CITY.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.CITY,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.INVALID_COUNTRY.errorCode,
      {
        errorCode: AddressErrorMap.INVALID_COUNTRY.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.COUNTRY,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.INVALID_STATE.errorCode,
      {
        errorCode: AddressErrorMap.INVALID_STATE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.STATE,
        callBack: () => {},
      },
    ],

    [
      AddressErrorMap.INVALID_POSTAL.errorCode,
      {
        errorCode: AddressErrorMap.INVALID_POSTAL.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.ZIP,
        callBack: () => {},
      },
    ],

    [
      AddressErrorMap.INVALID_LINE1.errorCode,
      {
        errorCode: AddressErrorMap.INVALID_LINE1.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.INVALID_LINE2.errorCode,
      {
        errorCode: AddressErrorMap.INVALID_LINE2.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.APARTMENT,
        callBack: () => {},
      },
    ],

    [
      AddressErrorMap.ADDRESS_PO_BOX.errorCode,
      {
        errorCode: AddressErrorMap.ADDRESS_PO_BOX.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.ADDRESS_NOT_DELIVERABLE.errorCode,
      {
        errorCode: AddressErrorMap.ADDRESS_NOT_DELIVERABLE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.BUSINESS_ADDRESS_FOR_CARD_SHIP_INVALID.errorCode,
      {
        errorCode: AddressErrorMap.BUSINESS_ADDRESS_FOR_CARD_SHIP_INVALID.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.BUSINESS_ADDRESS_MUST_BE_US.errorCode,
      {
        errorCode: AddressErrorMap.BUSINESS_ADDRESS_MUST_BE_US.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
    [
      AddressErrorMap.BUSINESS_REGISTERED_ADDRESS_NOT_EXIST.errorCode,
      {
        errorCode: AddressErrorMap.BUSINESS_REGISTERED_ADDRESS_NOT_EXIST.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LINE1,
        callBack: () => {},
      },
    ],
  ]);
};
